<template>
  <div>
    <v-card-text
      v-if="selectedApplication.allCoursesApproved"
      class="mt-0 pa-0 mb-2"
    >
      <MessageBox>
        <template v-if="selectedApplication.transferOldProfession">
          <h5>DENNA ANMÄLAN GÄLLER FLYTT AV LÄRLING TILL NYTT FÖRETAG.</h5>
          <p class="fontsize-14">
            Personen har sedan tidigare en godkänd grundutbildning. Du kan godkänna förlyttningen genom att klicka på knappen.
          </p>
        </template>

        <template v-else>
          <h5>DENNA PERSON VERKAR HA EN KOMPLETT GRUNDUTBILDNING</h5>
          <p class="fontsize-14">
            Dokumenten verkar visa på att personen har en komplett grundutbildning. Du kan godkänna grundutbildningen genom att klicka på knappen.
          </p>
        </template>

        <div>

          <!-- Action button to approve moving apprenticeship -->
          <v-btn
            style="width: auto"
            v-if="get(selectedApplication, 'transferOldProfession', false)"
            class="mb-3"
            @click="approveTransfer()"
            :disabled="disabledButton"
          >
            <v-icon>$sl-add</v-icon>{{ selectedApplication.transferOldProfession ? 'Godkänn förflyttning' : 'Godkänn grundutb.' }}
          </v-btn>

          <v-btn
            style="width: auto"
            v-else-if="!certificateIsCreated"
            class="mb-3"
            @click="$emit('confirm-education', {
              edModal: true,
              edMode: 'create',
              addTitle: 'Godkänn grundutb.'
            })"
            :disabled="!approvedStateByCompany || !(selectedApplication && selectedApplication.allCoursesApproved)"
          >
            <v-icon>$sl-add</v-icon>{{ selectedApplication.transferOldProfession ? 'Godkänn förflyttning' : 'Godkänn grundutb.' }}
          </v-btn>

          <v-btn
            style="width: auto"
            class="mb-3"
            v-else-if="!certificateIsApproved && certificateIsCreated && showMode"
            :disabled="certificateIsApproved && showMode != true ? true : false"
            @click="$emit('confirm-education', {
                edModal: true,
                edMode: 'approve',
                addTitle: showMode ? 'BEKRÄFTA GODKÄNNANDE AV GRUNDUTB.' : 'GODKÄNN GRUNDUTBILDNING'
            })"
          >
            Bekräfta godk. av GU
          </v-btn>
          <v-btn
            class="mb-3"
            style="width: auto"
            v-else
            outlined
            @click="$emit('confirm-education', {edModal: true})"
            disabled
          >
            <v-icon></v-icon>{{ showMode ? 'Bekräfta godk. av GU' : 'Godkänn grundutb.' }}
          </v-btn>
          <v-btn class="mb-3 ml-3" v-if="canUndoCreateEducation" @click="undoCreateEducation()"> <v-icon>$sl-cancel</v-icon>Ångra</v-btn>
        </div>
      </MessageBox>
    </v-card-text>

    <v-data-table
      :headers="[
          {
            text: 'Kurs',
            sortable: false,
            filterable: false,
            value: 'courseName',
            width: '200'
          },
          {
            text: 'Kod',
            sortable: false,
            filterable: false,
            value: 'courseCode',
            width: '120'
          },
          {
            text: 'Källa',
            sortable: false,
            filterable: false,
            value: 'source',
            width: '120'
          },
          {
            text: 'OCR-Resultat*',
            sortable: false,
            filterable: false,
            value: 'ocrApproved',
            width: '120'
          },
          {
            text: 'Enligt Lärling',
            sortable: false,
            filterable: false,
            value: 'apprenticeApproved',
            width: '120'
          },
          {
            text: 'Regionärs Bedömning',
            sortable: false,
            filterable: false,
            value: 'approved',
            width: '120'
          }
        ]"
      :items="getItems"
      :loading="isLoading"
      :items-per-page="itemsPerPage"
      hide-default-footer
      item-key="id"
      class="small"
    >
      <template
        slot="item.approved"
        slot-scope="props"
      >
        <v-select
          filled
          class="result"
          disabled
          :class="props.item.approved == true ? 'approve' : props.item.approved == false ? 'notApprove' : 'missing'"
          :items="selectItems"
          v-model="props.item.approved"
          item-text="name"
          item-value="approved"
        >
        </v-select>
      </template>

      <template
        slot="item.ocrApproved"
        slot-scope="props"
      >
        <div>
          <template v-if="props.item.ocrApproved">
            <span class="Oval green"></span> <span>Godkänd</span>
          </template>
          <template v-else>
            <span class="missing">(saknas)</span>
          </template>
        </div>
      </template>

      <template
        slot="item.apprenticeApproved"
        slot-scope="props"
      >
        <div>
          <template v-if="props.item.apprenticeApproved">
            <span class="Oval green"></span> <span>Godkänd</span>
          </template>
          <template v-else>
            <span class="missing">(saknas)</span>
          </template>
        </div>
      </template>

      <template
        slot="item.source"
        slot-scope="props"
      >
        <div>
          {{ get(props, 'item.source.value', '') }}
        </div>
      </template>

    </v-data-table>

    <v-row>
      <v-col cols="6">
        <template v-if="certificateIsApproved || certificateIsCreated">
          <strong>Historik</strong>
          <div v-if="certificateIsCreated">
            <span>{{ get(selectedApplication,"education.basicEducationCertificate.createdAt", null) | date }}</span>:
            <span> Grundutbildning godkänd</span>
            <span v-if="get(selectedApplication, 'education.basicEducationCertificate.createdBy', null)">
              (<a @click="showUser(get(selectedApplication, 'education.basicEducationCertificate.createdById'))">{{ get(selectedApplication, 'education.basicEducationCertificate.createdBy.firstName', '') }} {{ get(selectedApplication, 'education.basicEducationCertificate.createdBy.lastName', '') }}</a>)
            </span>
          </div>
          <div v-if="certificateIsApproved">
            <span>{{ get(selectedApplication,"education.basicEducationCertificate.approvedAt", null) | date }}</span>:
            <span> Godkännande av grundutbildning bekräftad</span>
            <span>
              (<a @click="showUser(get(selectedApplication, 'education.basicEducationCertificate.approvedById'))">{{ get(selectedApplication, 'education.basicEducationCertificate.approvedBy.firstName', '') }} {{ get(selectedApplication, 'education.basicEducationCertificate.approvedBy.lastName', '') }}</a>)
            </span>
          </div>
        </template>
      </v-col>
      <v-col cols="6">
        *OCR-resultat (“optical character recognition”) uppnås genom maskinläsning av betygsfilerna. OCR-tekniken har
        varierande träffsäkerhet. Var därför vänlig och förlita dig inte helt på OCR-resultatet utan kontrollera också
        att det stämmer.
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import get from 'lodash/get'
import MessageBox from '@/components/common/MessageBox.vue'
import {RulesMixin, UserRules, DownloadsMixin} from '@/components/mixins'
import API from '@/services/api'

export default {
  name: 'ApplicationEducationView',

  props: {
    certificateIsCreated: {
      type: Boolean,
      required: true
    },

    certificateIsApproved: {
      type: Boolean,
      required: true
    },

    getItems: {
      type: Array,
      required: true
    },

    selectItems: {
      type: Array,
      required: true
    },

    itemsPerPage: {
      type: Number,
      required: true
    },

    propEducation: {
      type: Object,
      default: () => ({})
    }
  },

  mixins: [RulesMixin, UserRules, DownloadsMixin],

  components: {
    MessageBox
  },

  computed: {
    ...mapGetters('application', [
      'selectedApplication',
      'applicationProfession',
      'applicationOrders',
      'applicationDistanceEductions',
      'applicationWorkplace',
      'canBeEdited',
      'approvedStateByCompany'
    ]),
    ...mapGetters('app', ['isLoading']),
    ...mapGetters('basic', ['getStateByStatename', 'approvedByByn', 'orderedState']),
    ...mapGetters('currentuser', ['currentUser', 'currentUserRole']),

    // THIS NEED TO BE CHECKED AGAIN WHEN WE ARE DONE
    showMode() {
      if (
        this.selectedApplication.education &&
        this.selectedApplication.education.regionId &&
        this.selectedApplication.education.basicEducationCertificate &&
        this.selectedApplication.education.basicEducationCertificate.createdById
      ) {
        return this.canUserApprove(
          this.selectedApplication.education.regionId,
          this.selectedApplication.education.basicEducationCertificate.createdById
        )
      }
      return false
    },

    disabledButton() {
      const approvedById = this.selectedApplication?.transferApprovedById
      const regionId = this.selectedApplication?.regionId
      const isTransferOldProfessionApproved = this.selectedApplication?.transferOldProfessionApproved

      let bool = false

      if ( !this.canUserApprove(regionId, approvedById) ) bool = true
      if ( isTransferOldProfessionApproved ) bool = true
      if ( !this.approvedStateByCompany && !approvedById) bool = true

      return bool
    },

    canUndoCreateEducation(){
      return this.certificateIsCreated 
        && !this.certificateIsApproved 
        && this.selectedApplication 
        && this.selectedApplication.education
        && this.selectedApplication.education.basicEducationCertificate
        && this.selectedApplication.education.basicEducationCertificate.createdById === this.currentUser.id
    }
  },

  methods: {
    ...mapActions('user', ['setSelectedUser']),
    ...mapActions('application', ['updateSelectedApplication']),

    get,

    async showUser(id) {
      await this.setSelectedUser(null)
      this.$nextTick(() => {
        this.$router.push({name: 'User', params: {id}})
      })
    },

    async approveTransfer() {
      try {
        if ( !this.selectedApplication?.transferOldProfession ) return

        const res = await this.$dialog.confirm({
          text: "Du godkänner härmed flytt till nytt företag.",
          title: "Vill du godkänna flytt till nytt företag?",
          width: "550",
          actions: [
            { text: "Avbryt", key: false, icon: "$sl-cancel" },
            { text: "Godkänn", key: true, icon: "$sl-approve", outlined: true },
          ],
        });

        if (res !== true) return;

        if ( !this.selectedApplication?.transferApprovedById ) {
          await API.updateApplication(this.selectedApplication.id, { data: { shouldUpdateTransferApplication: true, transferApprovedById: this.currentUser.id } })
          return this.$emit('saved')
        }

        const { apprenticeship, personId } = this.propEducation || {}
        if( !apprenticeship  ) throw new Error('Lärlingsanmälan saknar angiven lärlingsplats, vilket krävs för att anmälan ska kunna godkännas.')
        if ( !personId ) throw new Error('Lärlingsanmälan saknar angivet person-ID, vilket krävs för att anmälan ska kunna godkännas.')

        const data = {
          employmentTypeId: this.selectedApplication?.employmentTypeId,
          companyId: this.selectedApplication?.companyId,
          instructorId: this.selectedApplication?.instructorId,
          personId: this.selectedApplication?.personId,
          professionId: this.selectedApplication?.professionId,
          toDate: get(apprenticeship, 'toDate', null),
          fromDate: this.selectedApplication?.employmentDate,
          workplaceIds: [this.selectedApplication?.workplaceId]
        }
        
        await API.moveApprenticeship(apprenticeship?.id, this.selectedApplication?.companyId, { data: data })
        await API.updateApplication(this.selectedApplication.id, { data: { 
            transferApprovedBySecondaryId: this.currentUser.id, 
            transferOldProfessionApproved: true,
            shouldUpdateTransferApplication: true 
          } 
        })

        this.$events.fire('showInfo', 'Flytten till det nya företaget har genomförts.') 
        this.$emit('saved')

      } catch (error) {
        this.$events.fire('showError', get(error, 'message', null) || 'Flytten till det nya företaget kunde tyvärr inte genomföras.') 
        console.log(error)
      }
    },

    undoCreateEducation(){
      API.undoCreateEducation(this.selectedApplication.id)
        .then(() => {       
          this.$emit('saved')
        })
        .catch(error => {
          console.log('error :>> ', error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>